import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { gameStore, GameState } from '../game/store';
type ChatMsg = {
  id: string;
  user: string;
  text: string;
  color: string;
  isDonation?: boolean;
};
const USERS = [{
  name: 'Blorgon7',
  color: 'text-cyan-300'
}, {
  name: "Zkt'xur",
  color: 'text-purple-300'
}, {
  name: 'TheManWhoSoldTheGalaxy',
  color: 'text-green-300'
}, {
  name: 'Krrkrrrk',
  color: 'text-pink-300'
}, {
  name: 'Xenomorph_Fan99',
  color: 'text-yellow-300'
}, {
  name: 'QueenOfSector12',
  color: 'text-red-300'
}, {
  name: 'Unit_4471_Beeps',
  color: 'text-blue-300'
}, {
  name: 'GranMa_Hkzz',
  color: 'text-orange-300'
}, {
  name: 'Toenail_Connoisseur',
  color: 'text-fuchsia-300'
}, {
  name: 'Dr_Wormhole',
  color: 'text-teal-300'
}, {
  name: 'AnonymousOrb',
  color: 'text-gray-400'
}, {
  name: 'Fleshmother',
  color: 'text-rose-300'
}];
const AMBIENT_MESSAGES = ["lol he's BAREFOOT", 'carl my beloved', 'Subscribe for more toes', 'this is my favorite crawler', 'the cat should get its own show', 'KICK KICK KICK KICK', 'mordecai is literally me', 'I told my wife about this guy', 'the goblin king is going to eat him', 'WHERE ARE HIS SHOES', 'First!! (is what I would say if I was embarrassing)', 'I am rooting for the goblins', 'no I am not', 'how does one become a sponsor', 'please walk slower so I can screenshot', 'the audio quality of his grunts is immaculate', '4 stars. would watch die again.', 'has anyone asked if carl is okay', 'the answer is obviously no', 'i named my pet after him', 'my pet is also barefoot now', 'WOW', 'F', 'RIP bozo', 'pathetic', 'underrated gameplay', 'somebody give this man a sandwich', "he is going to DIE isn't he", 'the crawler-feet-to-goblin-face ratio is PERFECT', 'i will be watching until the end. even if the end is today.'];
const KILL_MESSAGES = ['LMAOOOO', 'OWNED', 'GET REKT GOBLIN', 'POGGG', 'SHEEESH', 'BRUTAL', 'that was art', 'chefs kiss', 'the foot connected. I felt that.'];
const HURT_MESSAGES = ['OOF', 'oh no carl', 'yikes', 'my poor baby', 'that looked expensive', 'pain'];
const DONATION_MESSAGES = ['keep going, you beautiful creature', 'for the toes', 'my wife left me and this is all i have', 'GRANDMA SAYS HI', 'carl pls mention my hatchling', 'worth every credit'];
let msgCounter = 0;
export function LiveChat() {
  const [state, setState] = useState<GameState>(gameStore.getState());
  const [messages, setMessages] = useState<ChatMsg[]>([]);
  useEffect(() => gameStore.subscribe(setState), []);
  // Generate ambient messages
  useEffect(() => {
    if (state.phase !== 'playing') return;
    const interval = setInterval(() => {
      const user = USERS[Math.floor(Math.random() * USERS.length)];
      const text = AMBIENT_MESSAGES[Math.floor(Math.random() * AMBIENT_MESSAGES.length)];
      pushMessage(user.name, text, user.color);
    }, 3500 + Math.random() * 3000);
    return () => clearInterval(interval);
  }, [state.phase]);
  // React to kills
  const lastKillsRef = useRef(state.kills);
  useEffect(() => {
    if (state.kills > lastKillsRef.current) {
      const burst = Math.min(3, state.kills - lastKillsRef.current);
      for (let i = 0; i < burst; i++) {
        setTimeout(() => {
          const user = USERS[Math.floor(Math.random() * USERS.length)];
          const text = KILL_MESSAGES[Math.floor(Math.random() * KILL_MESSAGES.length)];
          pushMessage(user.name, text, user.color);
        }, i * 250);
      }
    }
    lastKillsRef.current = state.kills;
  }, [state.kills]);
  // React to health drops
  const lastHealthRef = useRef(state.health);
  useEffect(() => {
    if (state.health < lastHealthRef.current - 10 && state.health > 0) {
      const user = USERS[Math.floor(Math.random() * USERS.length)];
      const text = HURT_MESSAGES[Math.floor(Math.random() * HURT_MESSAGES.length)];
      pushMessage(user.name, text, user.color);
    }
    lastHealthRef.current = state.health;
  }, [state.health]);
  // Occasional donations on high viewership
  useEffect(() => {
    if (state.phase !== 'playing') return;
    const interval = setInterval(() => {
      if (state.viewership > 60 && Math.random() < 0.4) {
        const user = USERS[Math.floor(Math.random() * USERS.length)];
        const amount = [5, 10, 20, 50, 100][Math.floor(Math.random() * 5)];
        const text = DONATION_MESSAGES[Math.floor(Math.random() * DONATION_MESSAGES.length)];
        pushMessage(user.name, `$${amount} — ${text}`, user.color, true);
      }
    }, 8000);
    return () => clearInterval(interval);
  }, [state.phase, state.viewership]);
  const pushMessage = (user: string, text: string, color: string, isDonation = false) => {
    const id = `msg_${msgCounter++}`;
    setMessages(prev => [...prev.slice(-6), {
      id,
      user,
      text,
      color,
      isDonation
    }]);
    setTimeout(() => {
      setMessages(prev => prev.filter(m => m.id !== id));
    }, 7000);
  };
  if (state.phase !== 'playing' || state.isGameOver) return null;
  return <div className="absolute right-3 top-44 md:top-56 w-64 max-h-96 overflow-hidden pointer-events-none z-30 flex flex-col-reverse gap-1" data-id="element-119">
      <AnimatePresence initial={false} data-id="element-120">
        {messages.slice().reverse().map(msg => <motion.div key={msg.id} initial={{
        opacity: 0,
        x: 20,
        height: 0
      }} animate={{
        opacity: 1,
        x: 0,
        height: 'auto'
      }} exit={{
        opacity: 0,
        x: 30,
        transition: {
          duration: 0.3
        }
      }} transition={{
        duration: 0.25
      }} className={`text-xs leading-snug px-2 py-1 border-l-2 ${msg.isDonation ? 'bg-yellow-950/60 border-yellow-400 text-yellow-200' : 'bg-black/40 border-gray-700'}`} data-id="element-121">
              {msg.isDonation && <span className="text-yellow-400 font-bold uppercase tracking-wider text-[10px]" data-id="element-122">
                  ★ DONATION ★<br data-id="element-123" />
                </span>}
              <span className={`font-bold ${msg.color}`} data-id="element-124">{msg.user}</span>
              <span className="text-gray-300" data-id="element-125">: {msg.text}</span>
            </motion.div>)}
      </AnimatePresence>
    </div>;
}